<template>
	<div class="footer">
		<footer>
			<div class="left">
				<p class="title-xinwen">新闻中心</p>
				<p class="title-compay">公司新闻</p>
				<p class="title-compay">行业要闻</p>
			</div>
			<div class="center-l">
				<p class="cn">厦门市东合信息技术有限公司</p>
				<p class="en">Xiamen Danhar Information Technology Co. Ltd.</p>
				<p>智慧法务践行者</p>
			</div>
			<div class="center-r">
				<img src="../assets/images/code.png" alt="" class="img_code">
				<p class="tip">微信公众号</p>
			</div>
			<div class="right">
				<img src="../assets/images/tel.png" alt="" class="img_tel">
				<p class="mobile-txt">联系电话</p>
				<p class="mobile">400-0592-110</p>
				<p>数字法治 智慧司法</p>
			</div>
		</footer>
		<p class="copy">Copyright © 2019 厦门市东合信息技术有限公司</p>
		<div style="text-align: center; padding: 10px">
			<a href="https://beian.miit.gov.cn/" target="_blank">闽ICP备14001608号-1</a>
		</div>
		
	</div>
</template>

<script>
export default {
  name: 'FooterHome',
  data() {
    return {

    }
  },
  mounted() {
  },
  created() {
    this.ab = ''
  },
  methods: {}
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
footer {
	margin-top: 120px;
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	.left {
		.title-xinwen {
			font-size: 18px;
			font-weight: bold;
			color: #000;
			margin-bottom: 30px;
		}
		.title-compay {
			font-size: 15px;
			color: #8a8989;
		}
	}
	.center-l {
		margin-top: 10px;
		font-size: 14px;
		color: #b5b5b6;
		.cn {
			font-size: 18px;
			letter-spacing: 2px;
			margin-bottom: 2px;
		}
		.en {
			font-size: 10px;
		}
		p:last-child {
			margin-top: 29px;
			font-size: 17px;
			text-align: center;
		}
	}
	.center-r {
		margin-top: -14px;
		.img_code {
			width: 106px;
			height: 106px;
		}
		.tip {
			color: #8a8989;
			font-size: 12px;
			text-align: center;
		}
	}
	.right {
		position: relative;
		padding-left: 50px;
		.img_tel {
			width: 30px;
			height: 30px;
			position: absolute;
			top: 0;
			left: 0;
		}
		.mobile-txt {
			color: #8a8989;
			font-size: 15px;
		}
		.mobile {
			color: #2392f4;
			font-size: 20px;
			margin-top: -6px;
		}
		p:last-child {
			color: #b5b5b6;
			margin-top: 32px;
		}
	}
}
.copy {
	text-align: center;
	margin-top: 18px;
	color: #8a8989;
	font-size: 12px;
}
</style>
